import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";

const TypeDocumentFilesDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
  inputType: string;
}> = ({ options, inputType }) => {

 const { data: categoriesResponse } = useParameterByFilter({
  page: 1,
  limit: 500,
  type: "categoryRoleOptions",
} as BaseInputFilter);

const DocumentFilesCategoryTypeOptions =
  (categoriesResponse?.data ?? []).map((item) => ({
    label: item.value,
    value: item.value,
  }));

const DocumentFilesIsPrivateTypeOptions = [
  { label: "Privado", value: true },
  { label: "Público", value: false },
];

  return (
    <Dropdown
      value={options.value}
      options={inputType === "isPrivate" ? DocumentFilesIsPrivateTypeOptions : DocumentFilesCategoryTypeOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o tipo"
      showClear
    />
  );
};
export default TypeDocumentFilesDropdown;